<template>
   <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="42"
   height="32"
   viewBox="0 0 256 194"
   version="1.1"
   id="svg8"
   inkscape:version="0.92.3 (2405546, 2018-03-11)"
   sodipodi:docname="chat_icon.svg">
  <defs
     id="defs2" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.7"
     inkscape:cx="207.76276"
     inkscape:cy="498.79053"
     inkscape:document-units="mm"
     inkscape:current-layer="g1094"
     showgrid="false"
     inkscape:window-width="1853"
     inkscape:window-height="1025"
     inkscape:window-x="1987"
     inkscape:window-y="27"
     inkscape:window-maximized="1"
     inkscape:pagecheckerboard="true" />
  <metadata
     id="metadata5">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(0,-103)">
    <g
       id="g1094"
       transform="matrix(3.0472016,0,0,3.0472016,-263.52219,-307.26552)"
       style="fill:#000000;fill-opacity:1">
      <g
         transform="matrix(0.02996982,0,0,0.02755704,119.47023,135.09522)"
         id="g881"
         style="fill:#ffffff;fill-opacity:1">
        <g
           id="comment"
           style="fill:#ffffff;fill-opacity:1">
          <g
             id="g865"
             style="fill:#ffffff;fill-opacity:1">
            <path
               transform="matrix(8.8283257,0,0,9.6012973,-3986.3513,-3414.5619)"
               id="path863"
               d="m 469.47461,355.73633 c -9.83392,0 -17.93359,7.36025 -17.93359,16.58203 v 46.30078 h 15.06445 v -46.30078 c 0,-1.63259 1.28866,-2.83398 2.86914,-2.83398 h 155.73047 c 1.62828,-10e-6 3.03906,1.25648 3.03906,2.83398 v 99.97656 c 0,1.58906 -1.43932,3.11328 -3.03906,3.11328 H 589.3457 c -4.13328,0 -7.54297,3.00416 -7.54297,6.80469 v 24.65234 l -39.58984,-29.92968 c -1.33944,-1.01278 -2.9903,-1.52735 -4.72461,-1.52735 h -17.90234 v 13.74805 h 15.21875 l 49.78711,37.625 c 1.36583,1.03361 3.05282,1.53711 4.75586,1.53711 l 3.15625,-0.66016 c 2.61805,-1.13713 4.25195,-3.56041 4.25195,-6.22265 v -32.2793 h 28.44922 c 9.9388,0 17.99219,-7.5982 17.99219,-16.86133 v -99.97656 c 0,-9.22167 -8.05339,-16.58203 -17.99219,-16.58203 z"
               style="stroke-width:0.10861652;fill:#ffffff;fill-opacity:1"
               inkscape:connector-curvature="0" />
          </g>
        </g>
        <g
           id="Layer_1"
           style="fill:#ffffff;fill-opacity:1" />
      </g>
      <g
         transform="matrix(-0.02996982,0,0,0.02755704,137.47403,151.73274)"
         id="g881-3"
         style="fill:#000000;fill-opacity:1">
        <g
           id="comment-6"
           style="fill:#000000;fill-opacity:1">
          <g
             id="g865-7"
             style="fill:#000000;fill-opacity:1" />
        </g>
        <g
           id="Layer_1-3"
           style="fill:#000000;fill-opacity:1" />
      </g>
      <g
         transform="translate(0,-0.52916667)"
         id="g1074"
         style="fill:#ffffff;fill-opacity:1">
        <g
           id="g1032"
           transform="matrix(-0.26458333,0,0,0.26458333,337.97571,-48.081409)"
           style="fill:#ffffff;fill-opacity:1">
          <g
             id="comment-5"
             style="fill:#ffffff;fill-opacity:1">
            <g
               id="g1016"
               style="fill:#ffffff;fill-opacity:1">
              <path
                 id="path1014"
                 d="m 893.71044,931.91452 c -1.71936,0 -3.42225,-0.51023 -4.80117,-1.56042 l -50.26298,-38.22872 h -65.95596 c -9.92814,0 -18.10638,-7.72089 -18.10638,-17.1325 V 773.4135 c 0,-9.36961 8.17824,-16.84637 18.10638,-16.84637 h 157.2221 c 10.03406,0 18.16355,7.47687 18.16355,16.84637 v 101.57969 c 0,9.41162 -8.12949,17.13219 -18.16355,17.13219 h -28.72281 v 32.79751 c 0,2.70489 -1.64846,5.16683 -4.29159,6.32222 -1.02842,0.4492 -2.09262,0.66941 -3.18759,0.66941 z M 772.69033,770.53567 c -1.59563,0 -2.8969,1.21906 -2.8969,2.87783 v 101.57938 c 0,1.6725 1.32825,3.16386 2.8969,3.16386 h 68.66428 c 1.75092,0 3.41813,0.52383 4.7704,1.55284 l 39.96949,30.40825 V 885.0698 c 0,-3.86146 3.44169,-6.91295 7.61457,-6.91295 h 36.20336 c 1.61507,0 3.06843,-1.54913 3.06843,-3.16366 V 773.4135 c 0,-1.60279 -1.42455,-2.87783 -3.06843,-2.87783 z"
                 inkscape:connector-curvature="0"
                 style="stroke-width:0.11000687;fill:#ffffff;fill-opacity:1" />
            </g>
          </g>
          <g
             id="Layer_1-6"
             style="fill:#ffffff;fill-opacity:1" />
        </g>
        <ellipse
           transform="matrix(0.02996982,0,0,0.02755704,119.47023,135.09522)"
           style="opacity:0.98799995;fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:136.70245361;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:normal"
           id="path1036"
           cx="-521.03558"
           cy="1249.5518"
           rx="125.54145"
           ry="133.35817" />
        <ellipse
           transform="matrix(0.02996982,0,0,0.02755704,119.47023,135.09522)"
           style="opacity:0.98799995;fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:136.70245361;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:normal"
           id="path1036-2"
           cx="-191.76111"
           cy="1249.5518"
           rx="125.54144"
           ry="133.35817" />
        <ellipse
           style="opacity:0.98799995;fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:3.92857122;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:normal"
           id="path1036-9"
           cx="123.47852"
           cy="169.52916"
           rx="3.7624545"
           ry="3.6749563" />
      </g>
    </g>
  </g>
</svg>
</template>
<script>
export default {
  name: 'ChatIcon',
}
</script>
